const moreSvg = `<svg aria-hidden='true' viewBox='0,0,1792,1792'><title>More</title><path d='M979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zm384 0q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z'></path></svg>`;

const wheelchairSvg = `<span class='uw-sr-only'>Wheelchair accessible stop</span><svg class='wheelchair' aria-hidden='true' focusable='false' data-prefix='fas' data-icon='wheelchair' class='svg-inline--fa fa-wheelchair fa-w-16' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z'></path></svg>`;

export default function busStopPopup(model) {
	return `<div class='content-wrapper clearfix bus-stop' data-key='${model.key}'>
	<h3 id='stop-number'>Stop #${model.human_code}</h3>
	<p id='stop-details'>
		${model.data.title}
		${model.data.wheelchairs ? wheelchairSvg : ''}
	</p>
	<p>
		<button
			type='button'
			data-dialog-url='${model.htmlView}'
			class='more_button arrival_times_more'
			aria-describedby='stop-number stop-details stop-routes'
		>
			Arrival times
			${moreSvg}
		</button>
	</p>
	<p id='stop-routes'>Serves routes: ${model.data.routes}</p>
</div>`;
}
